export function dispatchOptionField(dispatch, form_component, value, optionFields, curStep, form_components, option = null, jumpHistory = []) {
	if (!Array.isArray(optionFields)) {
		return;
	}

	// Find current SE index
	let currentSEIndex = 0;
	let seMapping = {};
	form_components.forEach((comp, index) => {
		if (comp.format === 'SE') {
			currentSEIndex++;
			seMapping[comp._id] = currentSEIndex;
		}
	});

	const optionField = optionFields.find(optionField => optionField.fieldname === form_component.fieldname);
	
	if (optionField) {
		// Create new array by copying all existing fields
		const updatedOptionFields = [...optionFields];
		const fieldIndex = updatedOptionFields.findIndex(
			field => field.fieldname === form_component.fieldname
		);

		if (fieldIndex !== -1) {
			// For radio/select, directly use option's jump conditions
			if (form_component.input_type === 'radio' || form_component.input_type === 'select') {
				updatedOptionFields[fieldIndex] = {
					...updatedOptionFields[fieldIndex],
					value: value,
					jump_to_session: option?.jump_to_session || null,
					jump_to_se_index: option?.jump_to_session ? seMapping[option.jump_to_session] : 0,
					jump_to_seq: option?.seq || 0,
					seq: form_component.seq
				};
			}
			// For checkbox, handle multiple selections
			else if (form_component.input_type === 'checkbox') {
				const checkboxValues = value ? value.split(',') : [];
				if (checkboxValues.length > 0 && option?.jump_to_session) {
					updatedOptionFields[fieldIndex] = {
						...updatedOptionFields[fieldIndex],
						value: value,
						jump_to_session: option.jump_to_session,
						jump_to_se_index: seMapping[option.jump_to_session],
						jump_to_seq: option?.seq || 0,
						seq: form_component.seq
					};
				}
			}
		}

		dispatch({type: 'SET_OPTION_FIELDS', payload: updatedOptionFields});

		// Only calculate next step if we have a jump condition
		if (option?.jump_to_session) {
			// Check if the jump condition is to submit the form
			if (option.jump_to_session === 'submit_form') {
				console.log('jump_to_session detected as form_submit, recording jump history entry.');
				const newJumpHistory = [
					...jumpHistory,
					{
						from: curStep,
						to: curStep + 1, // Adjust this if you want a different next step when submitting
						fieldname: form_component.fieldname,
						value: value,
						jump_to_session: 'submit_form'
					}
				];
				console.log('Setting jump history:', newJumpHistory);
				dispatch({ type: 'SET_JUMP_HISTORY', payload: newJumpHistory });
				console.log('Setting next step to:', curStep + 1);
				dispatch({ type: 'SET_NEXT_STEP', payload: curStep + 1 });
				return;
			}

			const seIndex = seMapping[option.jump_to_session];
			if (seIndex) {
				// Simply append to jump history
				const newJumpHistory = [
					...jumpHistory,
					{
						from: curStep,
						to: seIndex,
						fieldname: form_component.fieldname,
						value: value,
						jump_to_session: option.jump_to_session
					}
				];

				console.log('Setting jump history:', newJumpHistory);
				dispatch({ type: 'SET_JUMP_HISTORY', payload: newJumpHistory });

				// Then set next step
				console.log('Setting next step to:', seIndex);
				dispatch({ type: 'SET_NEXT_STEP', payload: seIndex });
			} else {
				console.log('No SE index found, going to next step:', curStep + 1);
				dispatch({ type: 'SET_NEXT_STEP', payload: curStep + 1 });
			}
		} else {
			console.log('No jump condition, going to next step:', curStep + 1);
			dispatch({ type: 'SET_NEXT_STEP', payload: curStep + 1 });
		}
	}
}